import { useState } from 'react';
import { CheckCircle2 } from 'lucide-react';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
  wtRequestId: number | null;
  airexOrderId?: string;
  amountVnd?: number | null;
}

export default function ConfirmApproveWidget({ isOpen, onClose, onConfirm, wtRequestId, airexOrderId, amountVnd }: Props) {
  const [loading, setLoading] = useState(false);
  if (!isOpen || !wtRequestId) return null;

  const handleConfirm = async () => {
    if (loading) return;
    setLoading(true);
    try {
      await Promise.resolve(onConfirm());
      onClose();
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/60 dark:bg-black/70 backdrop-blur-sm flex items-center justify-center z-[210]">
      <div className="bg-white dark:bg-gray-800 rounded-2xl p-6 max-w-md w-full mx-4 border border-gray-200 dark:border-gray-700 shadow-2xl">
        <div className="flex items-center gap-3 mb-4">
          <div className="p-2 rounded-lg bg-emerald-100 dark:bg-emerald-900/30">
            <CheckCircle2 className="w-6 h-6 text-emerald-600 dark:text-emerald-400" />
          </div>
          <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100">Подтверждение заявки</h3>
        </div>
        <p className="text-gray-700 dark:text-gray-300 mb-5">
          Подтвердить WT-заявку <strong>#{wtRequestId}</strong>
          {airexOrderId && <> (#{airexOrderId})</>}?
        </p>
        {typeof amountVnd === 'number' && amountVnd > 0 ? (
          <div className="mb-5 rounded-xl border border-emerald-200 bg-emerald-50/70 px-3 py-2 text-sm text-emerald-800 dark:border-emerald-900/50 dark:bg-emerald-900/20 dark:text-emerald-300">
            Сумма заявки: <strong>{Math.round(amountVnd).toLocaleString('ru-RU')} VND</strong>
          </div>
        ) : null}
        <div className="flex gap-3">
          <button
            onClick={handleConfirm}
            disabled={loading}
            className="flex-1 bg-emerald-600 hover:bg-emerald-700 text-white py-2.5 px-4 rounded-xl disabled:opacity-60 disabled:cursor-not-allowed disabled:hover:bg-emerald-600"
          >
            {loading ? 'Подтверждение…' : 'Да, подтвердить'}
          </button>
          <button
            onClick={onClose}
            className="flex-1 bg-gray-200 hover:bg-gray-300 dark:bg-gray-700 dark:hover:bg-gray-600 py-2.5 px-4 rounded-xl text-gray-800 dark:text-gray-200"
          >
            Нет
          </button>
        </div>
      </div>
    </div>
  );
}
